import {getHeaderHeight, scrollIntoView} from "../utils/functions";

const question_accordion = document.getElementById('question_accordion');
const about_accordion = document.getElementById('about_accordion');
const vakancies_accordion = document.getElementById('vakancies_accordion');
const reporting_accordion = document.getElementById('reporting_accordion');

if (question_accordion) {
    question_accordion.querySelectorAll('.accordion-collapse').forEach((el) => {
        el.addEventListener('shown.bs.collapse',(e) => {
            let scrollOffset = ((question_accordion) ? question_accordion.scrollTop : 0) + el.parentNode.offsetTop;
            let top = scrollOffset + -getHeaderHeight();

            console.debug('question_accordion::shown', {
                scrollOffset,
                top
            });

            window.scroll({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        })
    })
}

if (about_accordion) {
    about_accordion.querySelectorAll('.accordion-collapse').forEach((el) => {
        el.addEventListener('shown.bs.collapse',(e) => {
            let scrollOffset = ((about_accordion) ? about_accordion.scrollTop : 0) + el.parentNode.offsetTop;
            let top = scrollOffset + -getHeaderHeight();

            console.debug('question_accordion::shown', {
                scrollOffset,
                top
            });

            window.scroll({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        })
    })
}

if (vakancies_accordion) {
    vakancies_accordion.querySelectorAll('.accordion-collapse').forEach((el) => {
        el.addEventListener('shown.bs.collapse',(e) => {
            let scrollOffset = ((vakancies_accordion) ? vakancies_accordion.scrollTop : 0) + el.parentNode.offsetTop;
            let top = scrollOffset + -getHeaderHeight();

            console.debug('question_accordion::shown', {
                scrollOffset,
                top
            });

            window.scroll({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        })
    })
}

if (reporting_accordion) {
    reporting_accordion.querySelectorAll('.accordion-collapse').forEach((el) => {
        el.addEventListener('shown.bs.collapse',(e) => {
            let scrollOffset = ((reporting_accordion) ? reporting_accordion.scrollTop : 0) + el.parentNode.offsetTop;
            let top = scrollOffset + -getHeaderHeight();

            console.debug('question_accordion::shown', {
                scrollOffset,
                top
            });

            window.scroll({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        })
    })
}
